<template>
	<div class="productArticle">

		<div class="wrap">
				<div class="calculation-size">
				<h6> Size Definition</h6>
				<div class="calculation-wrap">
					<P style="">Note: The recommended size is suitable for current feet length. Considering kid's feet are still growing, you can choose one larger size than usual at most, any mistake caused by too large size option shall be borned by individuals.</P>
					<br>
					<div class="ways">
						<h4>Measurement Method</h4>
						<div class="box">
							<div class="way-item"   @click="$router.push('/article')">
								<img src="../../assets/111.png">
								<h3>How to measure feet？</h3>
							</div>
							<div class="way-item" @click="dialogVideoVisible=true">
								<img src="../../assets/222.png">
								<h3>Video for feet measurement</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content" id="Size">

				<div class="item-shop">
					<h5>Comfort Last</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
							<th colspan="2">
								Wide
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>
						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>80</td>
							<td>188</td>
							<td>84</td>
							<td>194</td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>83</td>
							<td>194</td>
							<td>87</td>
							<td>200</td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>86</td>
							<td>200</td>
							<td>89</td>
							<td>206</td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>88</td>
							<td>206</td>
							<td>91</td>
							<td>212</td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>89</td>
							<td>210</td>
							<td>92</td>
							<td>216</td>
						</tr>
						<tr>
							<td>37#</td>
							<td>240</td>
							<td>90</td>
							<td>213</td>
							<td>93</td>
							<td>219</td>
						</tr>
						<tr>
							<td>38#</td>
							<td>245</td>
							<td>91</td>
							<td>216</td>
							<td>94</td>
							<td>222</td>
						</tr>
						<tr>
							<td>39#</td>
							<td>250</td>
							<td>92</td>
							<td>219</td>
							<td>96</td>
							<td>225</td>
						</tr>
						<tr>
							<td>40#</td>
							<td>255</td>
							<td>94</td>
							<td>222</td>
							<td>97</td>
							<td>228</td>
						</tr>
						<tr>
							<td>41#</td>
							<td>260</td>
							<td>95</td>
							<td>226</td>
							<td>99</td>
							<td>232</td>
						</tr>


						<tr>
							<td>42#</td>
							<td>265</td>
							<td>96</td>
							<td>229</td>
							<td>100</td>
							<td>235</td>
						</tr>
						<tr>
							<td>43#</td>
							<td>270</td>
							<td>98</td>
							<td>232</td>
							<td>102</td>
							<td>241</td>
						</tr>
						<tr>
							<td>44#</td>
							<td>275</td>
							<td>99</td>
							<td>235</td>
							<td>103</td>
							<td>244</td>
						</tr>
						<tr>
							<td>45#</td>
							<td>280</td>
							<td>100</td>
							<td>238</td>
							<td>104</td>
							<td>246</td>
						</tr>

					</table>
				</div>
				<div class="item-shop">
					<h5>Long Distance Last</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
							<th colspan="2">
								Wide
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>
						</tr>

						<tr>
							<td>25#</td>
							<td>180</td>
							<td>66</td>
							<td>168</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>26#</td>
							<td>185</td>
							<td>67</td>
							<td>170</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>27#</td>
							<td>190</td>
							<td>68</td>
							<td>172</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>28#</td>
							<td>195</td>
							<td>69</td>
							<td>174</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>70</td>
							<td>176</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>30#</td>
							<td>205</td>
							<td>72</td>
							<td>180</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>73</td>
							<td>184</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>32#</td>
							<td>215</td>
							<td>75</td>
							<td>188</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>77</td>
							<td>192</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>34#</td>
							<td>225</td>
							<td>78</td>
							<td>194</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>79</td>
							<td>198</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>80</td>
							<td>200</td>
							<td>84</td>
							<td>213</td>
						</tr>
						<tr>
							<td>37#</td>
							<td>240</td>
							<td>82</td>
							<td>203</td>
							<td>86</td>
							<td>215</td>
						</tr>
						<tr>
							<td>38#</td>
							<td>245</td>
							<td>84</td>
							<td>205</td>
							<td>88</td>
							<td>217</td>
						</tr>
						<tr>
							<td>39#</td>
							<td>250</td>
							<td>85</td>
							<td>210</td>
							<td>90</td>
							<td>219</td>
						</tr>
						<tr>
							<td>40#</td>
							<td>255</td>
							<td>86</td>
							<td>212</td>
							<td>92</td>
							<td>222</td>
						</tr>
						<tr>
							<td>41#</td>
							<td>260</td>
							<td>87</td>
							<td>217</td>
							<td>94</td>
							<td>226</td>
						</tr>
						<tr>
							<td>42#</td>
							<td>265</td>
							<td>89</td>
							<td>220</td>
							<td>95</td>
							<td>230</td>
						</tr>
						<tr>
							<td>43#</td>
							<td>270</td>
							<td>90</td>
							<td>222</td>
							<td>96</td>
							<td>234</td>
						</tr>
						<tr>
							<td>44#</td>
							<td>275</td>
							<td>91</td>
							<td>226</td>
							<td>97</td>
							<td>238</td>
						</tr>
						<tr>
							<td>45#</td>
							<td>280</td>
							<td>92</td>
							<td>229</td>
							<td>98</td>
							<td>242</td>
						</tr>
						<tr>
							<td>46#</td>
							<td>285</td>
							<td>93</td>
							<td>232</td>
							<td>99</td>
							<td>246</td>
						</tr>


					</table>
				</div>

				<div class="item-shop">
					<h5>Sprint Last</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>
						</tr>
						<tr>
							<td>25#</td>
							<td>180</td>
							<td>61.6</td>
							<td>161.5</td>
						</tr>
						<tr>
							<td>26#</td>
							<td>185</td>
							<td>63.1</td>
							<td>165.0</td>
						</tr>
						<tr>
							<td>27#</td>
							<td>190</td>
							<td>64.7</td>
							<td>168.5</td>
						</tr>
						<tr>
							<td>28#</td>
							<td>195</td>
							<td>66.2</td>
							<td>172.0</td>
						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>67.8</td>
							<td>175.5</td>
						</tr>
						<tr>
							<td>30#</td>
							<td>205</td>
							<td>69.3</td>
							<td>179.0</td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>70.9</td>
							<td>182.5</td>
						</tr>
						<tr>
							<td>32#</td>
							<td>215</td>
							<td>72.4</td>
							<td>186.0</td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>74.0</td>
							<td>189.5</td>
						</tr>
						<tr>
							<td>34#</td>
							<td>225</td>
							<td>75.5</td>
							<td>193.0</td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>77.1</td>
							<td>196.5</td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>78.6</td>
							<td>200.0</td>
						</tr>
						<tr>
							<td>37#</td>
							<td>240</td>
							<td>80.2</td>
							<td>203.5</td>
						</tr>
						<tr>
							<td>38#</td>
							<td>245</td>
							<td>81.7</td>
							<td>207.0</td>
						</tr>
						<tr>
							<td>39#</td>
							<td>250</td>
							<td>83.3</td>
							<td>210.5</td>
						</tr>
						<tr>
							<td>40#</td>
							<td>255</td>
							<td>84.8</td>
							<td>214.0</td>
						</tr>
						<tr>
							<td>41#</td>
							<td>260</td>
							<td>86.4</td>
							<td>217.5</td>
						</tr>
						<tr>
							<td>42#</td>
							<td>265</td>
							<td>87.9</td>
							<td>221.0</td>
						</tr>
						<tr>
							<td>43#</td>
							<td>270</td>
							<td>89.5</td>
							<td>224.5</td>
						</tr>
						<tr>
							<td>44#</td>
							<td>275</td>
							<td>91.0</td>
							<td>228.0</td>
						</tr>
						<tr>
							<td>45#</td>
							<td>280</td>
							<td>92.6</td>
							<td>231.5</td>
						</tr>

					</table>
				</div>

				<div class="item-shop">
					<h5>Marathon Last I</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>

						</tr>

						<tr>
							<td>25#</td>
							<td>180</td>
							<td>69.2</td>
							<td>172.5</td>
						</tr>
						<tr>
							<td>26#</td>
							<td>185</td>
							<td>70.4</td>
							<td>176.0</td>
						</tr>
						<tr>
							<td>27#</td>
							<td>190</td>
							<td>71.6</td>
							<td>179.5</td>
						</tr>
						<tr>
							<td>28#</td>
							<td>195</td>
							<td>72.8</td>
							<td>183.0</td>
						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>74.0</td>
							<td>186.5</td>
						</tr>
						<tr>
							<td>30#</td>
							<td>205</td>
							<td>75.2</td>
							<td>190.0</td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>76.4</td>
							<td>193.5</td>
						</tr>
						<tr>
							<td>32#</td>
							<td>215</td>
							<td>77.6</td>
							<td>197.0</td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>78.8</td>
							<td>200.5</td>
						</tr>
						<tr>
							<td>34#</td>
							<td>225</td>
							<td>80.0</td>
							<td>204.0</td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>81.2</td>
							<td>207.5</td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>82.4</td>
							<td>211.0</td>
						</tr>
						
					

					</table>
				</div>

				<div class="item-shop">
					<h5>Marathon Last II</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
							<th colspan="2">
								Wide
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>

							<th>
								Width
							</th>
							<th>
								Circumference
							</th>

						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>71.9</td>
							<td>183.0</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>30#</td>
							<td>205</td>
							<td>73.5</td>
							<td>186.5</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>75.0</td>
							<td>190.0</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>32#</td>
							<td>215</td>
							<td>76.5</td>
							<td>193.5</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>78.1</td>
							<td>197.0</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>34#</td>
							<td>225</td>
							<td>79.6</td>
							<td>200.5</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>81.2</td>
							<td>204.0</td>
							<td>84.4</td>
							<td>206.0</td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>82.7</td>
							<td>207.5</td>
							<td>86.0</td>
							<td>209.5</td>
						</tr>
						<tr>
							<td>37#</td>
							<td>240</td>
							<td>84.2</td>
							<td>211.0</td>
							<td>87.5</td>
							<td>213.0</td>
						</tr>
						<tr>
							<td>38#</td>
							<td>245</td>
							<td>85.8</td>
							<td>214.5</td>
							<td>89.1</td>
							<td>216.5</td>
						</tr>
						<tr>
							<td>39#</td>
							<td>250</td>
							<td>87.3</td>
							<td>218.0</td>
							<td>90.6</td>
							<td>220.0</td>
						</tr>
						<tr>
							<td>40#</td>
							<td>255</td>
							<td>88.9</td>
							<td>221.5</td>
							<td>92.2</td>
							<td>223.5</td>
						</tr>
						<tr>
							<td>41#</td>
							<td>260</td>
							<td>90.4</td>
							<td>225.0</td>
							<td>93.7</td>
							<td>227.0</td>
						</tr>
						<tr>
							<td>42#</td>
							<td>265</td>
							<td>92.0</td>
							<td>228.5</td>
							<td>95.3</td>
							<td>230.5</td>
						</tr>
						<tr>
							<td>43#</td>
							<td>270</td>
							<td>93.5</td>
							<td>232.0</td>
							<td>96.8</td>
							<td>234.0</td>
						</tr>
						<tr>
							<td>44#</td>
							<td>275</td>
							<td>95.1</td>
							<td>235.5</td>
							<td>98.4</td>
							<td>237.5</td>
						</tr>
						<tr>
							<td>45#</td>
							<td>280</td>
							<td>96.6</td>
							<td>239.0</td>
							<td>99.9</td>
							<td>241.0</td>
						</tr>
						<tr>
							<td>46#</td>
							<td>285</td>
							<td>98.1</td>
							<td>242.5</td>
							<td>101.4</td>
							<td>244.5</td>
						</tr>



					</table>
				</div>

				<div class="item-shop">
					<h5>All Road Last</h5>
					<table border="1" width="100%" align="center" cellpadding="0" cellspacing="0">
						<tr>
							<th rowspan="2">
								Size
							</th>
							<th rowspan="2">
								Length
							</th>
							<th colspan="2">
								Average
							</th>
						</tr>
						<tr>
							<th>
								Width
							</th>
							<th>
								Circumference
							</th>

						</tr>
						<tr>
							<td>25#</td>
							<td>180</td>
							<td>67.8</td>
							<td>175.5</td>
						</tr>
						<tr>
							<td>26#</td>
							<td>185</td>
							<td>69.2</td>
							<td>179.0</td>
						</tr>
						<tr>
							<td>27#</td>
							<td>190</td>
							<td>70.6</td>
							<td>182.5</td>
						</tr>
						<tr>
							<td>28#</td>
							<td>195</td>
							<td>72.0</td>
							<td>186.0</td>
						</tr>
						<tr>
							<td>29#</td>
							<td>200</td>
							<td>73.4</td>
							<td>189.5</td>
						</tr>
						<tr>
							<td>30#</td>
							<td>205</td>
							<td>74.8</td>
							<td>193.0</td>
						</tr>
						<tr>
							<td>31#</td>
							<td>210</td>
							<td>76.2</td>
							<td>196.5</td>
						</tr>
						<tr>
							<td>32#</td>
							<td>215</td>
							<td>77.6</td>
							<td>200.0</td>
						</tr>
						<tr>
							<td>33#</td>
							<td>220</td>
							<td>79.0</td>
							<td>203.5</td>
						</tr>
						<tr>
							<td>34#</td>
							<td>225</td>
							<td>80.4</td>
							<td>207.0</td>
						</tr>
						<tr>
							<td>35#</td>
							<td>230</td>
							<td>81.8</td>
							<td>210.5</td>
						</tr>
						<tr>
							<td>36#</td>
							<td>235</td>
							<td>83.2</td>
							<td>214.0</td>
						</tr>
						<tr>
							<td>37#</td>
							<td>240</td>
							<td>84.6</td>
							<td>217.5</td>
						</tr>
						<tr>
							<td>38#</td>
							<td>245</td>
							<td>86.0</td>
							<td>221.0</td>
						</tr>
						<tr>
							<td>39#</td>
							<td>250</td>
							<td>87.4</td>
							<td>224.5</td>
						</tr>
						<tr>
							<td>40#</td>
							<td>255</td>
							<td>88.8</td>
							<td>228.0</td>
						</tr>
						<tr>
							<td>41#</td>
							<td>260</td>
							<td>90.2</td>
							<td>231.5</td>
						</tr>
						<tr>
							<td>42#</td>
							<td>265</td>
							<td>91.6</td>
							<td>235.0</td>
						</tr>
						<tr>
							<td>43#</td>
							<td>270</td>
							<td>93.0</td>
							<td>238.5</td>
						</tr>
						<tr>
							<td>44#</td>
							<td>275</td>
							<td>94.4</td>
							<td>242.0</td>
						</tr>
						<tr>
							<td>45#</td>
							<td>280</td>
							<td>95.8</td>
							<td>245.5</td>
						</tr>
						<tr>
							<td>46#</td>
							<td>285</td>
							<td>97.2</td>
							<td>249.0</td>
						</tr>


					</table>
				</div>

				

				<div style="height:100px;" id="Version"></div>
				<div class="item-shop" >
					<h5>Last</h5>
					<img src="../../assets/xuantou.png" width="100%"> 
				</div>
			</div>

			<button class="return" @click="closeWindow">
				Back
			</button>
		</div>
		<el-dialog title="Video for feet measurement" :visible.sync="dialogVideoVisible"  :width="web?'94%':'600px'">
			<iframe width="560" height="315" src="https://www.youtube.com/embed/zz8AqaH1ROU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';

	export default {
		name: "we",
		data() {
			return {
			   dialogTestVisible:false,
               dialogVideoVisible: false,
               long: 0,
			   wide: 0,
			   recommendata: {},
			}
		},
		computed: {
			...mapState({
				productDetails: state => state.productData,
				contact: state => state.contact,
				web: state => state.web,

			}),
		},
		mounted() {
            
		},
		methods: {
			closeWindow(){
                window.close();
			},
            recommend() {
				var data = {
					long: this.long,
					wide: this.wide,
				}
				var that = this;

				this.$api("index/getCalculate", data).then(res => {
					that.recommendata = res.data;
				})
			},


		}

	}
</script>


<style lang="less">

    	.calculation-size {
		  >h6 {
			font-size: 20px;
			font-weight: bold;
			color: #333;
			text-align: center;
		}

		.calculation-wrap {
			padding: 50px;
            font-size:16px;
            color:#666;
			.ways {
				h4 {
					color: #9cd223;
					font-size: 16px;
					line-height: 1;
					text-align: center;
					border-bottom: 1px solid #9cd223;
					padding-bottom: 20px;
					position: relative;

					&:after {
						content: "";
						width: 0;
						height: 0;
						border: 14px solid transparent;
						border-top-color: #9cd223;
						position: absolute;
						bottom: -28px;
						left: 50%;
						transform: translateX(-50%);
					}
				}
				.box {
					justify-content: center;
					display: flex;
					.way-item {
						margin: 0 30px;
						margin-top: 40px;
						cursor: pointer;
						h3 {
							font-size: 14px;
							line-height: 3;
						}
					}
				}

			}

			.button-wrap {
				text-align: center;
				padding: 40px 0;
			}

			.form-wrap {
				display: flex;

				.num-item {
					flex: 1;
					justify-content: center;
					display: flex;
					align-items: center;

					input {
						margin: 0 20px;
						padding-left: 10px;
						line-height: 50px;
						border: 1px solid #e5e5e5;
						border-radius: 4px;
						width: 90px;
					}
				}
			}
		}
	}
	.productArticle {
        margin-top:96px;
		td {
			text-align: center;
		}
		.item-shop{
			margin-bottom:6%;
		}

		min-height:calc(100vh - 150px);

		.wrap {
			width: 900px;
			margin: 0 auto;
			padding-bottom:10%;
            
            .item-shop{

            }
			.return {
				background: #90c31f;
				font-size: 14px;
				color: #fff;
				line-height: 50px;
				margin-top: 30px;
				width: 250px;
				text-align: center;
				display: block;
			}

			h6 {
				font-size: 24px;
				padding-top: 50px;
				font-weight: bold;
				margin-bottom: 3%;
			}

			.content {
				line-height: 1.6;
				font-size: 16px;
				padding: 50px 0;
				min-height: 30vh;
				color: #333333;
				border-top: 1px solid #dcdddd;
				border-bottom: 1px solid #dcdddd;

				h5 {
					text-align: center;
					font-size: 24px;
					font-weight: bold;
					line-height: 4;
				}
			}
		}
	}

	@media screen and (max-width:768px) {
         
        .productArticle{
        	.wrap{
        		width:94%;	
        		h6{
        			font-size:16px;
        			padding-top:20px;
        		}
        		.content{
        			padding-top:0;
        			h5{
        				font-size:16px;
        			}
        		}
        		.calculation-wrap{
        			padding:0;
        			.ways{
        				.box{
        					.way-item{
        						margin:10px;
        						margin-top:20px;
        						img{
        							width:100%;
        						}
        					}
        				}
        			}
        		}
        	}
        }
	}
</style>



// WEBPACK FOOTER //
// src/pages/product/productArticle.vue